import { createContext } from "react";

export const EstimateCommentsContext = createContext(null);